import { Accordion, styled } from '@mui/material';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import _StarIcon from '@/assets/images/icons/favourite_star_gray.svg?react';
import _SupportIcon from '@/assets/images/icons/support-icon.svg?react';

export const AsideDrawer = styled(Drawer)(({ theme }) => ({
    [theme.breakpoints.up('sm')]: {
        display: 'flex',
    },
    [theme.breakpoints.up('md')]: {
        display: 'none',
    },
    '& .MuiDrawer-paper': {
        boxSizing: 'border-box',
        width: '100%',
        backgroundColor: theme.palette.primitives.woodsmoke[1000],
        color: '#fff',
        backgroundImage: 'none',
        padding: '20px 8px 11px 8px',
    },
}));

export const CustomAvatar = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    width: '16px',
    height: '16px',
    backgroundColor: theme.palette.secondary.main,
    color: 'common.white',
    fontWeight: 700,
    fontSize: '12px',
}));

export const AccordionStyled = styled(Accordion)(() => ({
    background: 'transparent',
    borderRadius: '6px',
    '&:before': {
        display: 'none',
    },
}));

export const FooterWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    marginTop: 'auto',
    padding: '8px 0 0',
    gap: '16px',
    backgroundColor: theme.palette.backgrounds.layoutHeaderBg,
}));

export const MenuContent = styled(Box)(() => ({
    padding: '0 8px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: '4px',
}));

export const StarIcon = styled(_StarIcon)({});

export const SupportIcon = styled(_SupportIcon)({
    fontSize: '24px',
});
